import { DashboardItemService } from 'app/overview/dashboard/dashboard_item.service';
import { AssetCollection } from 'app/shared/collections/asset_collection.service';
import { View } from 'app/shared/collections/view';
import { ViewCollection } from 'app/shared/collections/view_collection.service';
import { ZoneCollection } from 'app/shared/collections/zones/zone_collection.service';
import { DynamicStatsManager } from 'app/shared/dynamic_stats_manager.service';
import { ImageUrlService } from 'app/shared/image_url.service';
import { ImsItemTypeRegistry } from 'app/shared/ims_items/ImsItemTypeRegistry';
import { ImsPanelService } from 'app/shared/ims_panel.service';
import { MapOptionsService } from 'app/shared/map_options/MapOptionsService';
import { SelectionService } from 'app/shared/selection/SelectionService';
import { ClockHandler } from 'app/shared/time/clock_handler.service';
import { ViewStateService } from 'app/shared/view_state.service';
import { ImsObjectVisibilityService } from 'app/shared/visibility/ImsObjectVisibilityService';
import { BaseViewController } from 'app/views/BaseViewController';
import { GenericViewController } from 'app/views/view_types/generic/GenericViewController';

type ViewControllerFactory = (view: View) => BaseViewController;

export function createGenericViewController(
    view: View,
    assetOptionsService: MapOptionsService,
    zoneOptionsService: MapOptionsService,
    imsItemTypeRegistry: ImsItemTypeRegistry,
    imageUrlService: ImageUrlService,
    dashboardItemService: DashboardItemService,
    assetCollection: AssetCollection,
    zoneCollection: ZoneCollection,
    clockHandler: ClockHandler,
    imsObjectVisibilityService: ImsObjectVisibilityService,
    selectionService: SelectionService,
): GenericViewController {
    const centerPanelTags = view?.centerPanelWidgetConfig?.widgets;
    return new GenericViewController(
        assetOptionsService,
        zoneOptionsService,
        imsItemTypeRegistry,
        imageUrlService,
        dashboardItemService,
        assetCollection,
        zoneCollection,
        clockHandler,
        imsObjectVisibilityService,
        selectionService,
        centerPanelTags,
    );
}

/**
 * Collects all the views from the API via the View Collection
 *  * then turns them into View Controller instances
 *  * populates the ViewStateService and ImsPanelService with the details,
 *  * then lets the DynamicStatsManager know we're done
 */
export async function collectViewsAndCreateViewControllers(
    viewCollection: ViewCollection,
    viewStateService: ViewStateService,
    imsPanelService: ImsPanelService,
    dynamicStatsManager: DynamicStatsManager,
    viewControllerFactory: ViewControllerFactory,
): Promise<void> {
    const views = await viewCollection.getAllAsArrayAsync();
    for (const view of views) {
        const ctrl = viewControllerFactory(view);
        // pass our view controller to the view state service
        viewStateService.setViewController(view.name, ctrl);
        // make sure the panel service knows about our center panel tags
        imsPanelService.setViewTags(view.name, 'center', ctrl.centerPanelTags);
    }

    // once the view state service is populated
    //  time to register dynamic stats
    await dynamicStatsManager.registerDynamicStats();
}
